export const faqData = {
  seoText: 'Common questions and answers about our wedding websites',
  title: 'Just the FAQs',
  content:
    'We’re here to help troubleshoot and solve any speed bumps you may encounter. Have questions? We’re here to help! Our most commonly asked questions are below, and you can reach our support team at <a class="faq-link" href="mailto:support@withjoy.com">support@withjoy.com</a>. <br/><br/>Looking for a Joy couple? <a class="faq-link" aria-label="Find an Event" href="/find/">Click here</a>.',
  generalHeader: 'General',
  websiteHeader: 'Wedding<br/>Website',
  rsvpHeader: 'Guests & RSVP',
  appHeader: 'Mobile App',
} as const;
